var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[_c('router-view',{attrs:{"pe_startWatchPosition_f":_vm.pe_startWatchPosition_f,"pe_stopWatchPosition_f":_vm.pe_stopWatchPosition_f}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }